import { createContext } from 'react';
import { NavLinkProps } from 'react-router-dom';
import { IconType } from '../misc/IconDeprecated/IconDeprecated';
export const BreadcrumbsContext = createContext<BreadcrumbsContextValue>({
  get breadcrumbs(): never {
    throw new Error('BreadcrumbsContext not initialized, make sure you are inside the BreadcrumbsContext');
  },
  setBreadcrumbs: () => {
    throw new Error('BreadcrumbsContext not initialized, make sure you are inside the BreadcrumbsContext');
  }
});
export type BreadcrumbsContextValue = {
  breadcrumbs: Array<Breadcrumb>;
  setBreadcrumbs: (breadcrumbs: Array<Breadcrumb>) => void;
};
export type Breadcrumb = {
  iconName: string;
  iconType: IconType;
  to: NavLinkProps['to'];
  disabled: boolean;
};